import { useMutation } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

async function getInvoiceUrlRequest(invoiceId: string) {
  return (await get(`billing/invoices/${invoiceId}/download`)).link;
}

export default function useInvoiceUrl() {
  const { mutateAsync: fetchInvoiceUrl, isPending: isFetchingInvoiceUrl } =
    useMutation({
      mutationFn: ({ invoiceId }: { invoiceId: string }) =>
        getInvoiceUrlRequest(invoiceId),
    });

  return {
    fetchInvoiceUrl,
    isFetchingInvoiceUrl,
  };
}
